/* ==========================================================================
   SECOND DRAFT - theme behaviour
   ========================================================================== */
(function () {
  'use strict';

  var SD = window.SD || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------------- money */

  function formatMoney(cents, format) {
    var fmt = format || SD.moneyFormat || '₹{{amount}}';
    var value = (cents / 100);

    function thousands(num, sep, dec, places) {
      var parts = Math.abs(num).toFixed(places).split('.');
      var int = parts[0];
      var frac = parts[1];
      int = int.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return (num < 0 ? '-' : '') + int + (places && frac ? dec + frac : '');
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return thousands(value, ',', '.', 2);
        case 'amount_no_decimals': return thousands(value, ',', '.', 0);
        case 'amount_with_comma_separator': return thousands(value, '.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return thousands(value, '.', ',', 0);
        case 'amount_with_space_separator': return thousands(value, ' ', ',', 2);
        case 'amount_no_decimals_with_space_separator': return thousands(value, ' ', ',', 0);
        default: return thousands(value, ',', '.', 2);
      }
    });
  }
  SD.formatMoney = formatMoney;

  /* ------------------------------------------------------------- reveals */

  var io = null;
  function observeReveals(root) {
    if (!('IntersectionObserver' in window)) {
      $$('[data-rv]', root).forEach(function (el) { el.classList.add('in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px' });
    }
    $$('[data-rv]', root).forEach(function (el) { io.observe(el); });
  }

  /* -------------------------------------------------------------- scrim */

  var openLayers = [];

  function showScrim() {
    var s = $('#scrim');
    if (!s) return;
    s.hidden = false;
    requestAnimationFrame(function () { s.classList.add('on'); });
    document.documentElement.style.overflow = 'hidden';
  }
  function hideScrim() {
    var s = $('#scrim');
    if (!s) return;
    s.classList.remove('on');
    document.documentElement.style.overflow = '';
    setTimeout(function () { if (!s.classList.contains('on')) s.hidden = true; }, 360);
  }

  function openLayer(el) {
    if (!el) return;
    el.classList.add('on');
    el.removeAttribute('aria-hidden');
    if (openLayers.indexOf(el) === -1) openLayers.push(el);
    showScrim();
  }
  function closeLayer(el) {
    if (!el) return;
    el.classList.remove('on');
    el.setAttribute('aria-hidden', 'true');
    openLayers = openLayers.filter(function (x) { return x !== el; });
    if (!openLayers.length) hideScrim();
  }
  function closeAll() {
    openLayers.slice().forEach(closeLayer);
    var m = $('.modal.on');
    if (m) m.classList.remove('on');
    document.documentElement.style.overflow = '';
  }

  /* --------------------------------------------------------------- cart */

  function cartCountUpdate(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = '(' + count + ')'; });
  }

  function renderCartSection(html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('#cartDrawerInner');
    var current = $('#cartDrawerInner');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var count = parsed.querySelector('[data-cart-count-source]');
    if (count) cartCountUpdate(count.getAttribute('data-cart-count-source'));
  }

  function refreshCart(open) {
    return fetch(SD.routes.cart + '?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        renderCartSection(html);
        if (open) openLayer($('#cartDrawer'));
      });
  }

  function addToCart(items, opts) {
    opts = opts || {};
    var body = { items: items, sections: 'cart-drawer' };
    return fetch(SD.routes.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.data && (res.data.description || res.data.message)) || 'Could not add to bag.';
          if (opts.onError) opts.onError(msg); else alert(msg);
          return null;
        }
        if (res.data.sections && res.data.sections['cart-drawer']) {
          renderCartSection(res.data.sections['cart-drawer']);
          if (SD.cartDrawer) openLayer($('#cartDrawer'));
          else window.location.href = SD.routes.cart;
        } else {
          refreshCart(SD.cartDrawer);
        }
        return res.data;
      });
  }
  SD.addToCart = addToCart;

  function changeLine(key, quantity) {
    return fetch(SD.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.sections && d.sections['cart-drawer']) renderCartSection(d.sections['cart-drawer']);
        else refreshCart(false);
        if (document.body.classList.contains('template-cart')) window.location.reload();
        return d;
      });
  }

  /* ------------------------------------------------------------ quick add */

  function openQuickAdd(handle, colour) {
    var modal = $('#quickAddModal');
    if (!modal) return;
    var box = $('#quickAddBody', modal);
    box.innerHTML = '<div class="cempty"><span class="spinner"></span></div>';
    modal.classList.add('on');
    document.documentElement.style.overflow = 'hidden';

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var colourIndex = -1;
        p.options.forEach(function (o, i) {
          var n = (typeof o === 'string' ? o : o.name).toLowerCase();
          if (n === 'color' || n === 'colour') colourIndex = i;
        });
        var pool = p.variants;
        if (colour && colourIndex > -1) {
          var filtered = p.variants.filter(function (v) { return v.options[colourIndex] === colour; });
          if (filtered.length) pool = filtered;
        }

        var img = (pool[0] && pool[0].featured_image && pool[0].featured_image.src) || p.featured_image;
        var html = '';
        html += '<div class="dh" style="padding-inline:0;border:0">';
        html += '<span class="mono">' + SD.strings.quickAdd + '</span>';
        html += '<button class="mono dim" data-close-modal>' + SD.strings.close + '</button></div>';
        html += '<div style="display:grid;grid-template-columns:86px 1fr;gap:16px;align-items:center;margin-bottom:22px">';
        html += img ? '<div class="th" style="aspect-ratio:4/5;overflow:hidden;background:var(--bone)"><img src="' + img + '" alt="" style="width:100%;height:100%;object-fit:cover"></div>' : '<div></div>';
        html += '<div><h3 class="hd" style="font-size:17px;margin-bottom:5px">' + p.title + '</h3>';
        html += (colour ? '<div class="mono-xs dimmer" style="margin-bottom:6px">' + colour.toUpperCase() + '</div>' : '');
        html += '<div class="pr"><b class="price-now" style="font-size:19px">' + formatMoney(pool[0].price) + '</b></div></div></div>';

        html += '<div class="optlabel"><span class="mono">' + SD.strings.size + '</span><span class="mono dimmer" id="qaMsg">' + SD.strings.selectSize + '</span></div>';
        html += '<div class="sizes" id="qaSizes">';
        pool.forEach(function (v) {
          var label = v.options.filter(function (o, i) { return i !== colourIndex; }).join(' / ') || v.title;
          html += '<label><input type="radio" name="qa" value="' + v.id + '"' + (v.available ? '' : ' disabled') + '><span class="szbox">' + label + '</span></label>';
        });
        html += '</div>';
        html += '<button class="btn btn-p wide" id="qaAdd" style="margin-top:22px">' + SD.strings.addToBag + '</button>';
        html += '<a class="arrowlink dim" href="/products/' + p.handle + '" style="margin-top:16px">' + SD.strings.viewProduct + ' <i></i></a>';
        box.innerHTML = html;

        var addBtn = $('#qaAdd', box);
        addBtn.addEventListener('click', function () {
          var sel = $('#qaSizes input:checked', box);
          if (!sel) {
            var msg = $('#qaMsg', box);
            msg.textContent = SD.strings.pickSize;
            msg.style.color = 'var(--sale)';
            return;
          }
          addBtn.classList.add('is-loading');
          addToCart([{ id: parseInt(sel.value, 10), quantity: 1 }]).then(function () {
            addBtn.classList.remove('is-loading');
            modal.classList.remove('on');
            document.documentElement.style.overflow = '';
          });
        });
      })
      .catch(function () {
        box.innerHTML = '<div class="cempty">Could not load this product.</div>';
      });
  }

  /* -------------------------------------------------- predictive search */

  var searchTimer = null;
  function bindSearch() {
    var panel = $('#searchPanel');
    if (!panel) return;
    var input = $('#searchInput', panel);
    var results = $('#searchResults', panel);
    if (!input || !results) return;

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) { results.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        var url = SD.routes.predictive + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var inner = parsed.querySelector('#predictiveInner');
            results.innerHTML = inner ? inner.innerHTML : '';
            observeReveals(results);
          })
          .catch(function () { results.innerHTML = ''; });
      }, 220);
    });
  }

  /* ---------------------------------------------------------- size guide */

  function bindSizeGuide() {
    var modal = $('#sizeGuideModal');
    if (!modal) return;
    $$('[data-size-guide]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        modal.classList.add('on');
        document.documentElement.style.overflow = 'hidden';
      });
    });
    $$('.unit-toggle button', modal).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var unit = btn.getAttribute('data-unit');
        $$('.unit-toggle button', modal).forEach(function (b) { b.classList.toggle('on', b === btn); });
        $$('[data-in]', modal).forEach(function (cell) {
          var inches = parseFloat(cell.getAttribute('data-in'));
          if (isNaN(inches)) return;
          cell.textContent = unit === 'cm' ? (inches * 2.54).toFixed(1) : String(inches);
        });
        $$('[data-unit-label]', modal).forEach(function (l) { l.textContent = unit; });
      });
    });
  }

  /* ------------------------------------------------------- product page */

  function bindProductForm(scope) {
    var form = $('[data-product-form]', scope || document);
    if (!form) return;
    var holder = $('[data-variants-json]', form);
    var data = holder ? holder.textContent : form.getAttribute('data-variants');
    var variants = [];
    try { variants = JSON.parse(data || '[]'); } catch (e) { variants = []; }

    var idInput = $('[name="id"]', form);
    var addBtn = $('[data-add]', form);
    var priceNow = $('[data-price-now]');
    var priceWas = $('[data-price-was]');
    var priceChip = $('[data-price-chip]');
    var sizeMsg = $('[data-size-msg]');
    var stickyBtn = $('[data-sticky-add]');

    function currentOptions() {
      var opts = [];
      $$('[data-opt]', form).forEach(function (group) {
        var checked = $('input:checked', group);
        opts[parseInt(group.getAttribute('data-opt'), 10)] = checked ? checked.value : null;
      });
      return opts;
    }

    function match() {
      var opts = currentOptions();
      if (opts.indexOf(null) > -1) return null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function updateMedia(variant) {
      if (!variant) return;
      var colour = variant.colour;
      if (!colour) return;
      var any = false;
      $$('[data-media-colour]').forEach(function (el) {
        if (el.getAttribute('data-media-colour') === colour) any = true;
      });
      if (!any) return;
      $$('[data-media-colour]').forEach(function (el) {
        el.hidden = el.getAttribute('data-media-colour') !== colour;
      });
    }

    function update() {
      var v = match();
      var url = new URL(window.location.href);

      if (v) {
        idInput.value = v.id;
        if (priceNow) priceNow.textContent = formatMoney(v.price);
        if (priceWas) {
          if (v.compare > v.price) {
            priceWas.textContent = formatMoney(v.compare);
            priceWas.hidden = false;
          } else { priceWas.hidden = true; }
        }
        if (priceChip) {
          if (v.compare > v.price) {
            priceChip.textContent = Math.round((1 - v.price / v.compare) * 100) + '% ' + SD.strings.off;
            priceChip.hidden = false;
          } else { priceChip.hidden = true; }
        }
        [addBtn, stickyBtn].forEach(function (b) {
          if (!b) return;
          b.disabled = !v.available;
          b.textContent = v.available
            ? SD.strings.addToBag + ' - ' + formatMoney(v.price)
            : SD.strings.soldOut;
        });
        if (sizeMsg) { sizeMsg.style.color = ''; sizeMsg.textContent = v.available ? SD.strings.inStock : SD.strings.soldOut; }
        updateMedia(v);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } else {
        [addBtn, stickyBtn].forEach(function (b) {
          if (!b) return;
          b.disabled = true;
          b.textContent = SD.strings.pickSize;
        });
      }
    }

    $$('[data-opt] input', form).forEach(function (input) {
      input.addEventListener('change', function () {
        var group = input.closest('[data-opt]');
        var label = group && group.parentElement.querySelector('[data-opt-value]');
        if (label) label.textContent = input.value;
        update();
      });
    });

    form.addEventListener('submit', function (e) {
      if (!SD.cartDrawer) return;
      e.preventDefault();
      var v = match();
      if (!v) { if (sizeMsg) { sizeMsg.textContent = SD.strings.pickSize; sizeMsg.style.color = 'var(--sale)'; } return; }
      var qtyEl = $('[name="quantity"]', form);
      var qty = parseInt(qtyEl ? qtyEl.value : 1, 10) || 1;
      addBtn.classList.add('is-loading');
      addToCart([{ id: v.id, quantity: qty }]).then(function () { addBtn.classList.remove('is-loading'); });
    });

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }

    $$('[data-qty]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = $('[name="quantity"]', form);
        var val = parseInt(input.value, 10) || 1;
        val += parseInt(btn.getAttribute('data-qty'), 10);
        input.value = Math.max(1, val);
      });
    });

    update();
  }

  function bindStickyBar() {
    var bar = $('#stickyBar');
    var anchor = $('[data-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('on', !e.isIntersecting); });
    }, { rootMargin: '-120px 0px 0px 0px' }).observe(anchor);
  }

  /* ---------------------------------------------------------- newsletter */

  function bindLocalForms() {
    $$('[data-local-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[type="email"], input[type="text"]');
        if (!input || !input.value) { if (input) input.focus(); return; }
        var ok = document.createElement('div');
        ok.className = 'mono form-ok';
        ok.textContent = '✓ ' + input.value.toUpperCase();
        form.replaceWith(ok);
      });
    });
  }

  /* ------------------------------------------------------------ rails */

  function bindRails() {
    $$('[data-rail]').forEach(function (rail) {
      var id = rail.getAttribute('data-rail');
      $$('[data-rail-nav="' + id + '"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-dir') === 'prev' ? -1 : 1;
          rail.scrollBy({ left: dir * Math.min(rail.clientWidth * 0.8, 700), behavior: 'smooth' });
        });
      });
    });
  }

  /* --------------------------------------------------------------- init */

  function init() {
    observeReveals(document);
    bindSearch();
    bindSizeGuide();
    bindProductForm(document);
    bindStickyBar();
    bindLocalForms();
    bindRails();

    var hdr = $('#siteHeader');
    if (hdr) {
      var onScroll = function () { hdr.classList.toggle('tight', window.scrollY > 60); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var mmenu = $('#mmenu');
    $$('[data-open-menu]').forEach(function (b) { b.addEventListener('click', function () { mmenu.classList.add('on'); document.documentElement.style.overflow = 'hidden'; }); });
    $$('[data-close-menu]').forEach(function (b) { b.addEventListener('click', function () { mmenu.classList.remove('on'); document.documentElement.style.overflow = ''; }); });
    if (mmenu) $$('a', mmenu).forEach(function (a) { a.addEventListener('click', function () { mmenu.classList.remove('on'); document.documentElement.style.overflow = ''; }); });

    document.addEventListener('click', function (e) {
      var openCart = e.target.closest('[data-open-cart]');
      if (openCart) { e.preventDefault(); if (SD.cartDrawer) { openLayer($('#cartDrawer')); } else { window.location.href = SD.routes.cart; } return; }

      var openSearch = e.target.closest('[data-open-search]');
      if (openSearch) {
        e.preventDefault();
        openLayer($('#searchPanel'));
        setTimeout(function () { var i = $('#searchInput'); if (i) i.focus(); }, 260);
        return;
      }

      if (e.target.closest('[data-close-layer]') || e.target.id === 'scrim') { closeAll(); return; }

      var closeModal = e.target.closest('[data-close-modal]');
      if (closeModal) {
        var m = closeModal.closest('.modal');
        if (m) { m.classList.remove('on'); document.documentElement.style.overflow = ''; }
        return;
      }

      var qa = e.target.closest('[data-quick-add]');
      if (qa) {
        e.preventDefault();
        e.stopPropagation();
        openQuickAdd(qa.getAttribute('data-quick-add'), qa.getAttribute('data-colour') || '');
        return;
      }

      var rm = e.target.closest('[data-cart-remove]');
      if (rm) { e.preventDefault(); rm.closest('.citem').classList.add('is-loading'); changeLine(rm.getAttribute('data-cart-remove'), 0); return; }

      var step = e.target.closest('[data-cart-step]');
      if (step) {
        e.preventDefault();
        var key = step.getAttribute('data-cart-step');
        var q = parseInt(step.getAttribute('data-cart-qty'), 10);
        step.closest('.citem').classList.add('is-loading');
        changeLine(key, Math.max(0, q));
        return;
      }
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    document.addEventListener('shopify:section:load', function (e) {
      observeReveals(e.target);
      bindProductForm(e.target);
      bindLocalForms();
      bindRails();
      bindSizeGuide();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
